/// \file checkDataExists.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import * as React from "react";
//data will have the data to check in
//checkString will hold a string that we hope data contains

export const CheckDataExists = (props:{data:any,checkString:string}) => {
    const data = props.data;
    let checkString = props.checkString;
    checkString = checkString.replaceAll("[",".");
    checkString = checkString.replaceAll("]","");
    let TorF = true;
    const checkList = checkString.split(".");
    let dataIn = data
    try{if(data){
        for(let i=1;i<checkList.length && TorF;i++){
            if(false==Number.isNaN(Number(checkList[i]))){
                dataIn = dataIn.at(Number(checkList[i]));
            }
            else{
                dataIn = dataIn[checkList[i]];
            }
            if(dataIn==undefined){
                TorF = false;
            }
        }
    }
    else{
        TorF = false 
    }}
    catch{
        TorF = false
    }
    return (
        TorF
    );
};